import { HiMiniStar } from 'react-icons/hi2'

export function Stars({ value, title }) {
	return (
		<div className='tw-flex-none tw-px-4'>
			<h5 className='tw-text-base tw-text-gray-400 tw-m-0 tw-mt-3'>{title}</h5>
			<div className='tw-flex tw-items-center'>
				<span className='tw-font-bold tw-mr-2 tw-flex tw-items-center'>{value.toFixed(1)}</span>
				{[1, 2, 3, 4, 5].map(star => (
					<HiMiniStar key={star} size={18} className={`${value < star ? 'tw-text-gray-200' : 'tw-text-alert-300'}`} />
				))}
			</div>
		</div>
	)
}
